import { render, staticRenderFns } from "./CarCrashDetails.vue?vue&type=template&id=81821ed6&scoped=true"
import script from "./CarCrashDetails.vue?vue&type=script&lang=js"
export * from "./CarCrashDetails.vue?vue&type=script&lang=js"
import style0 from "./CarCrashDetails.vue?vue&type=style&index=0&id=81821ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.16_css-loader@6.11.0_webpack@5.99.9__lodash@4._1a4fa614c3ee0777424b4a1d2e42e909/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81821ed6",
  null
  
)

export default component.exports